export default __webpack_public_path__ + "static/media/uzeli-logo.a101cb61.svg";